export default "__VITE_ASSET__DYvj8uxK__"